import { render, staticRenderFns } from "./marketing-plan-template-publish-widget.vue?vue&type=template&id=44534132&scoped=true&"
import script from "./marketing-plan-template-publish-widget.vue?vue&type=script&lang=js&"
export * from "./marketing-plan-template-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./marketing-plan-template-publish-widget.vue?vue&type=style&index=0&id=44534132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44534132",
  null
  
)

export default component.exports